exports.querybuilder = function (obj) {
    let query = "?";
    for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            if (typeof obj[key] == 'function') continue;
            query += `${key}=${obj[key]}&`
        }
    }
    return query.substring(0, query.length - 1)
}